import { useQuery } from "react-query"
import PerkService from "../services/PerkService"
import { PerkRedemptionTypeShape } from "~shapes/perk"

const useRedemptionType = (perkId: string) => {
  const getRedemptionType = async (
    perkId: string,
  ): Promise<PerkRedemptionTypeShape> => {
    try {
      let response = await PerkService.getPerkRedemptionType(perkId)
      return response._embedded["perk-redemption-types"][0]
    } catch (e) {
      return Promise.reject(e)
    }
  }

  return useQuery(
    ["redemptionTypes", perkId],
    async () => await getRedemptionType(perkId),
    {
      enabled: !!perkId,
      staleTime: 10000,
      cacheTime: 10000,
    },
  )
}

export default useRedemptionType
